export const pageTitle = title => {
  return (document.title =
    title + ' -  GKC Klinica - Medical and Healthcare');
};
